import React from "react";

const directionAngles = {
  right: 0,
  down: 90,
  left: 180,
  up: 270,
};

const rotation = (direction = "right") => {
  const angle = directionAngles[direction];
  return `rotate(${angle} 7 7)`;
};

export default props => (
  <svg viewBox="0 0 14 14" {...props}>
    <title>Arrow Icon</title>
    <g transform={rotation(props.direction)}>
      <g
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g stroke="currentColor" strokeWidth={3}>
          <g transform="translate(3.500000, 1.500000)">
            <polyline points="0.550000095 0.5 3.2300001 3.12 5.9200001 5.74 3.1600001 8.28 0.400000095 10.82" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Arrow.js